import { render, staticRenderFns } from "./notificationCenter.vue?vue&type=template&id=c0af5296&scoped=true"
import script from "./notificationCenter.vue?vue&type=script&lang=js"
export * from "./notificationCenter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0af5296",
  null
  
)

export default component.exports